<template>
  <el-dialog
    :title="dialogTitle"
    :visible="dialogVisible"
    v-if="dialogVisible"
    @close="dialogClose"
    width="535px"
    top="10%"
    :close-on-click-modal="false"
  >
    <TipMsgDialog
      :userOptions="tipOptions"
      @tipMsgClose="tigMsgClose($event)"
      v-if="tipOptions.visible"
    ></TipMsgDialog>

    <el-alert
      :title="promptInfo"
      :description="ruletypeStr"
      type="warning"
      show-icon
      v-if="ruletypeStr != ''"
      style="margin-bottom:20px;"
      :closable="false"
    ></el-alert>

    <el-form
      ref="form"
      :model="form"
      :rules="rules"
      label-width="120px"
      class="form-box"
    >
      <el-form-item label="原密码" prop="OldPwd">
        <el-input
          type="password"
          v-model="form.OldPwd"
          maxlength="32"
        ></el-input>
      </el-form-item>
      <el-form-item label="新密码" prop="NewPwd1">
        <el-input
          type="password"
          v-model="form.NewPwd1"
          maxlength="32"
        ></el-input>
      </el-form-item>
      <el-form-item label="确认新密码" prop="NewPwd2">
        <el-input
          type="password"
          v-model="form.NewPwd2"
          maxlength="32"
        ></el-input>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="submitForm('form')">保 存</el-button>
      <el-button @click="dialogClose">取 消</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  data() {
    var checkNewPwd1 = (rule, value, callback) => {
      if (value === "") {
        callback();
      } else {
        if (value == this.form.OldPwd) {
          callback(new Error("新密码和原密码不能一样"));
        }
        if (this.ruletypeId > -1 && value.length < this.ruleLengthMin) {
          callback(new Error("密码长度不能小于" + this.ruleLengthMin));
        }
        if (this.ruletypeId > -1 && value.length > this.ruleLengthMax) {
          callback(new Error("密码长度不能大于" + this.ruleLengthMax));
        }
        if (this.ruletypeId == 0) {
          //字母数字，也允许特殊字符
          if (
            /^(?![0-9]+$)(?![a-zA-Z]+$)(?![a-zA-Z\W_!@#$%^&*`~()-+=]+$)(?![0-9\W_!@#$%^&*`~()-+=]+$)[0-9A-Za-z\W_!@#$%^&*`~()-+=]{8,}/.test(
              value
            ) == false
          ) {
            callback(new Error("格式错误(字母数字组合)"));
          } else {
            callback();
          }
        } else if (this.ruletypeId == 1) {
          //字母数字特殊字符
          if (
            /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![a-zA-Z0-9]+$)(?![A-Z\W_!@#$%^&*`~()-+=]+$)(?![a-z0-9]+$)(?![a-z\W_!@#$%^&*`~()-+=]+$)(?![0-9\W_!@#$%^&*`~()-+=]+$)[a-zA-Z0-9\W_!@#$%^&*`~()-+=]{8,}/.test(
              value
            ) == false
          ) {
            callback(new Error("格式错误(字母数字特殊字符组合)"));
          } else {
            callback();
          }
        } else {
          callback();
        }
      }
    };
    var checkNewPwd2 = (rule, value, callback) => {
      if (value === "") {
        callback();
      } else {
        if (value != this.form.NewPwd1) {
          callback(new Error("两次输入的新密码不一致"));
        } else {
          callback();
        }
      }
    };
    return {
      tipOptions: {
        showType: 0,
        visible: false,
        showDesp: true,
        desp: "稍后请在列表查看结果。"
      },
      isSuccess: false,
      ruletypeId: -1,
      ruletypeStr: "",
      ruleLengthMin: 0,
      ruleLengthMax: 0,
      form: {
        OldPwd: "",
        NewPwd1: "",
        NewPwd2: "",
        SerialNumber: ""
      },
      rules: {
        OldPwd: [{ required: true, message: "不能为空", trigger: "blur" }],
        NewPwd1: [
          { required: true, message: "不能为空", trigger: "blur" },
          { validator: checkNewPwd1, trigger: "blur" }
        ],
        NewPwd2: [
          { required: true, message: "不能为空", trigger: "blur" },
          { validator: checkNewPwd2, trigger: "blur" }
        ]
      }
    };
  },
  methods: {
    dialogClose: function() {
      this.$emit("dialogClose", false);
      this.resetForm("form");
    },
    tigMsgClose: function(value) {
      this.tipOptions.visible = value;
      if (this.isSuccess) this.$emit("dialogClose", false);
    },
    getPasswordRule() {
      this.$axios
        .post(
          "/Login/GetPasswordRuleLimit",
          { username: this.userName },
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded"
            }
          }
        )
        .then(
          function(res) {
            if (res.data.code == 1) {
              this.ruletypeId = res.data.result.Limit;
              this.ruletypeStr = "注意：新密码规则要求【" + res.data.msg + "】";
              this.ruleLengthMin = res.data.result.LengthMin;
              this.ruleLengthMax = res.data.result.LengthMax;
            } else {
              this.ruletypeId = -1;
              this.ruletypeStr = "";
              this.ruleLengthMin = 0;
              this.ruleLengthMax = 0;
            }
          }.bind(this)
        ) //bind(this)可以不用
        .catch(
          function(err) {
            if (err.response) {
              this.ruletypeId = -1;
              this.ruletypeStr = "";
              this.ruleLengthMin = 0;
              this.ruleLengthMax = 0;
            }
          }.bind(this)
        ); //bind(this)可以不用
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.form.SerialNumber = this.userName;
          console.log(this.form);
          this.$axios
            .post("/user/ModiPwd", this.form, {
              headers: {
                "Content-Type": "application/x-www-form-urlencoded"
              }
            })
            .then(
              function(res) {
                if (res.data.code == 1) {
                  //显示成功界面
                  this.tipOptions.showType = 0;
                  this.tipOptions.visible = true;
                  this.isSuccess = true;
                  this.tipOptions.desp = "密码修改成功";
                  this.$refs[formName].resetFields();
                } else {
                  //显示错误界面
                  this.tipOptions.showType = 1;
                  this.tipOptions.visible = true;
                  this.isSuccess = false;
                  this.tipOptions.desp = res.data.msg;
                }
              }.bind(this)
            ) //bind(this)可以不用
            .catch(
              function(err) {
                if (err.response) {
                  this.$message({
                    message: "服务器端错误，数据保存失败！" + err.message,
                    type: "error"
                  });
                }
              }.bind(this)
            ); //bind(this)可以不用
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  },
  props: ["dialogVisible", "dialogTitle", "userName", "promptInfo"]
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/password.vue